import React from 'react';
import ReactDOM from 'react-dom';
import { SageBreakpointProvider, SageTokens } from '@kajabi/sage-react';
import { initializeDatadogRum } from 'common/components/Datadog/Datadog';

import CheckoutContainer from 'apps/checkout';

document.addEventListener('DOMContentLoaded', () => {
  initializeDatadogRum({
    serviceName: 'kajabi-hero-signup',
  });

  ReactDOM.render(
    <SageBreakpointProvider queries={SageTokens.BREAKPOINT_QUERIES}>
      <CheckoutContainer />
    </SageBreakpointProvider>,
    document.getElementById('checkout-container'),
  );
});
